import { useAppContext, useView } from '../../hooks';
import CampaignModal from './CampaignModal';
import { formatDate } from '../../utilities';
import { useCampaigns } from './useCampaigns';
import { Slug, Button } from '../../components';
import { Dropdown, Table } from '../../components';
import { useCampaignActions } from './useCampaignActions';
import { Form, FormItem, TopPanel } from '../../components';

const getColor = (status: string): SlugColorType => {
  switch (status) {
    case 'active':
      return 'main';
    case 'inactive':
      return 'danger';
    case 'completed':
      return 'success';
    default:
      return 'main';
  }
};

const Tasks = () => {
  const {
    nodes,
    refresh,
    filters,
    setFilters,
    reloading,
    intializing: fetching,
  } = useCampaigns();
  const { refresh: refreshMeta } = useAppContext();

  const {
    element: actionElement,
    isOpened,
    updating,
    initialValues,

    handleAdd,
    handleStartAdd,
    handleClose,
    handleStartDelete,
    handleEdit,
    handleStartEdit,
  } = useCampaignActions(() => {
    refresh();
    refreshMeta();
  });

  const { element: viewElemenet, handleView } = useView();

  const loading = fetching || updating;

  return (
    <div className="flex flex-col gap-y-md w-full">
      {actionElement}
      {viewElemenet}
      {isOpened && (
        <CampaignModal
          loading={loading}
          initialValues={initialValues}
          onClose={handleClose}
          onSumbit={initialValues ? handleEdit : handleAdd}
        />
      )}
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="status" label="">
            <Dropdown
              placeholder="Status"
              grow={false}
              options={[
                { value: '', label: 'All Statuses' },
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
                { value: 'completed', label: 'Completed' },
              ]}
            />
          </FormItem>
        </Form>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
        <Button icon="plus" onClick={handleStartAdd}>
          Add Campaign
        </Button>
      </TopPanel>
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={fetching}
          config={{
            columns: [
              {
                header: 'Name',
                cellClassName: 'font-semibold',
                getValue: ({ name }) => name,
              },
              {
                header: 'Status',
                cellClassName: 'max-w-[12rem]',
                getValue: ({ status }) => (
                  <Slug
                    text={status}
                    color={getColor(status)}
                    className="max-w-[10rem]"
                  />
                ),
              },
              {
                header: 'Description',
                cellClassName: 'text-small',
                getValue: ({ description }) => description,
              },
              {
                header: 'Contacts',
                cellClassName: 'text-small',
                getValue: ({ contact_count }) => (
                  <Slug text={contact_count || 0} className="w-[3rem]" />
                ),
              },
              {
                header: 'Created',
                cellClassName: 'text-tiny',
                getValue: ({ created_at }) => formatDate(created_at),
              },
              {
                header: 'Actions',
                align: 'right',
                getValue: item => (
                  <div className="flex flex-row gap-x-sm justify-end">
                    <Button icon="eye" onClick={() => handleView(item)} />
                    <Button
                      icon="edit"
                      type="primary"
                      onClick={() => handleStartEdit(item)}
                    />
                    <Button
                      icon="delete"
                      type="danger"
                      onClick={() => handleStartDelete(item)}
                    />
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default Tasks;
